module.exports = __webpack_public_path__ + "static/media/oas_login.409b4a34.png";